
import * as entryServer from "/home/karnaud/Desktop/SacAPof/test/app/entry.server.tsx";
import * as route0 from "./root.tsx";
import * as route1 from "./routes/_index.tsx";
  export const mode = "development";
  export { default as assets } from "@remix-run/dev/assets-manifest";
  export const assetsBuildDirectory = "public/build";
  export const future = {};
  export const publicPath = "/build/";
  export const entry = { module: entryServer };
  export const routes = {
    "root": {
      id: "root",
      parentId: undefined,
      path: "",
      index: undefined,
      caseSensitive: undefined,
      module: route0
    },
  "routes/_index": {
      id: "routes/_index",
      parentId: "root",
      path: undefined,
      index: true,
      caseSensitive: undefined,
      module: route1
    }
  };